import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { MCP_CATALOG_MODE } from '../McpCatalogConstant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function McpCatalogFormHeader({ mode, isSubmitting, isFormValid, isFormDirty, onCancel, onSave, onDelete }) {
    useTranslationSubscription();
    // In edit mode, save is disabled until the user makes a change (isDirty)
    // In create mode, save is disabled only when form is invalid
    const isSaveDisabled = isSubmitting || !isFormValid || (mode === MCP_CATALOG_MODE.EDIT && !isFormDirty);

    return (
        <header className="mcp-catalog-form-header">
            <h3 className="mcp-catalog-form-title">
                {trI18n('MCP_CATALOG_FORM_TITLE')}
            </h3>
            <div className="mcp-catalog-form-header-actions">
                <Button
                    className="btn-hg32 btn-light"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                    onClick={onCancel}
                >
                    {trI18n('CM-BUTTON-CANCEL')}
                </Button>
                {mode === MCP_CATALOG_MODE.EDIT && onDelete && (
                    <Button
                        className="btn-delete btn-hg32"
                        variant="contained"
                        disabled={isSubmitting}
                        onClick={onDelete}
                    >
                        {trI18n('CM-BUTTON-DELETE')}
                    </Button>
                )}
                <Button
                    className="btn-hg32 btn-primary"
                    variant="contained"
                    color="primary"
                    disabled={isSaveDisabled}
                    onClick={onSave}
                >
                    {trI18n('CM-BUTTON-SAVE')}
                </Button>
            </div>
        </header>
    );
}

McpCatalogFormHeader.propTypes = {
    mode: PropTypes.oneOf([MCP_CATALOG_MODE.CREATE, MCP_CATALOG_MODE.EDIT]).isRequired,
    isSubmitting: PropTypes.bool,
    /** Whether the form currently passes all validation rules — controls Save button enabled state */
    isFormValid: PropTypes.bool,
    /** Whether the form has been modified by the user — in edit mode, Save requires dirty state */
    isFormDirty: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func
};

McpCatalogFormHeader.defaultProps = {
    isSubmitting: false,
    isFormValid: false,
    isFormDirty: false,
    onDelete: null
};
